import { render } from "./agregarDetalle.vue?vue&type=template&id=2daf0767&scoped=true"
import script from "./agregarDetalle.vue?vue&type=script&lang=js"
export * from "./agregarDetalle.vue?vue&type=script&lang=js"

import "./agregarDetalle.vue?vue&type=style&index=0&id=2daf0767&scoped=true&lang=css"
import "./agregarDetalle.vue?vue&type=style&index=1&id=2daf0767&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daf0767"]])

export default __exports__